/*
 * @Author: edvardchen
 * @Date:   2017-05-10 15:56:24
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-26 19:47:14
 */

import { combineReducers } from 'redux';

import installer from './installer';

import user from './user';

import sharepage from './sharepage';

const combined = combineReducers({
  user,
  installer,
  sharepage,
});

export default combined;
